import { Component, OnInit, Inject } from '@angular/core';
import { Role } from '../../models/role.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-edit-role',
    templateUrl: './role-details.dialog.html',
    styleUrls: ['./role-details.dialog.scss'],
    standalone: false
})
export class RoleDetailsDialog implements OnInit {
    // Properties.
    title: string;
    role: Role = new Role();
    originalRoleName: string = "";
    originalIsSiteLevel: boolean = false;
    defaultToFolderlevel: boolean = false;
    private showSiteLevelRoleWarning: boolean = true;
    private originalIsSiteTreeViewable: boolean = false;

    // Constructor.
    constructor(@Inject(MAT_DIALOG_DATA) data) {
        if (data != null) {
            if (data.role != null) {
                this.role = data.role;
                this.title = `Edit Role`
                this.defaultToFolderlevel = data.defaultToFolderlevel;
                this.originalRoleName = this.role.name;
                this.originalIsSiteLevel = this.role.isSiteLevel;
                this.originalIsSiteTreeViewable = this.role.isSiteTreeViewable;
            }
            else {
                this.role.isSiteLevel = !data.defaultToFolderlevel;
                this.title = `New Role`
            }

            if (data.showSiteLevelRoleWarning != null)
                this.showSiteLevelRoleWarning = data.showSiteLevelRoleWarning;
        } else {
            this.title = 'New Role';
        }
    }

    ngOnInit(): void {
    }

    public DisableSave(): boolean {
        if (!this.role?.name?.trim()) return true;
        return this.ShowCancel();
    }

    public ShowCancel(): boolean {
        if (!this.role.name) return true;
        if (this.originalRoleName == '' && this.role.name == '') {
            return true;
        }
        let sitelevelSiteTreeResult: boolean = this.role.isSiteLevel == this.originalIsSiteLevel && this.role.isSiteTreeViewable == this.originalIsSiteTreeViewable;

        return (this.role.name == this.originalRoleName && sitelevelSiteTreeResult);
    }

    public GetShowWarning(): boolean {
        return ((this.role.isSiteLevel == true) && (this.originalIsSiteLevel == false) && this.showSiteLevelRoleWarning && (this.originalIsSiteTreeViewable == false));
    }

    public reset(): void {
        this.role.name = this.originalRoleName;
        this.role.isSiteLevel = this.originalIsSiteLevel;
        this.role.isSiteTreeViewable = this.originalIsSiteTreeViewable;
    }

    /**Ensures that if the site level role checkbox is false that site tree visibility is also false*/
    public validateSiteTreeVisibility(): void {
        debugger;
        if (!this.role.isSiteLevel && this.role.isSiteTreeViewable)
            this.role.isSiteTreeViewable = false;
    }
}
